import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface KPIGridProps {
  children: ReactNode;
  columns?: 2 | 3 | 4 | 5;
  cols?: 2 | 3 | 4 | 5; // Alias for columns
  className?: string;
}

export function KPIGrid({ 
  children, 
  columns,
  cols,
  className = "" 
}: KPIGridProps) {
  const finalColumns = cols || columns || 4;
  
  const gridClasses = {
    2: "grid-cols-1 md:grid-cols-2",
    3: "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
    4: "grid-cols-1 md:grid-cols-2 lg:grid-cols-4",
    5: "grid-cols-1 md:grid-cols-3 lg:grid-cols-5",
  };

  return (
    <div 
      className={cn(
        "grid gap-4",
        gridClasses[finalColumns],
        className
      )}
    >
      {children}
    </div>
  );
}
